import { executeRequest, Request } from '@jfs/network'
import { getUserBody } from './../data/request/requestbody'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const addUser = (appUser: any, tokens: any, userAccessToken: string) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.AddUser,
    method: 'POST',
    config: sitConfig(tokens),
    headers: {
      Authorization: userAccessToken,
    },
    body: getUserBody(appUser),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { addUser }
